import React from "react";
import "../stylesheets/App.scss";
import Landing from "./landing/Landing";

const App = () => {
  return <Landing></Landing>;
};

export default App;
